'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiHeadphones = function TiHeadphones(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35 21.7c0-8.3-6.7-15-15-15s-15 6.7-15 15v4.3c0 0.1 0 0.1 0 0.2 0 0.4 0 0.8 0 1.3v3.3c0 3.2 2.6 5.9 5.8 5.9s5.9-2.7 5.9-5.9v-3.3c0-2.5-1.4-4.6-3.3-5.5 0.1-3.5 3-6.3 6.6-6.3s6.5 2.8 6.6 6.3c-1.9 0.9-3.3 3-3.3 5.5v3.3c0 3.2 2.7 5.9 5.9 5.9s5.8-2.7 5.8-5.9v-3.3c0-0.5 0-0.9 0-1.3 0-0.1 0-0.1 0-0.2v-4.3z m-26.7 0c0-2.7 0.9-5.1 2.4-7.1l1.5 1.5c-1.2 1.6-2 3.5-2.2 5.6 0 0 0 1.6 0 1.6h-1.7v-1.6z m5 9.1c0 1.4-1.1 2.5-2.5 2.5s-2.5-1.1-2.5-2.5v-3.3c0-1.1 0.1-2 0.2-2.5h3.2c0.8 0 1.6 1 1.6 2.5v3.3z m13-15.5l-0.6 0.6c-1.5-1.6-3.6-2.4-5.7-2.4s-4.2 0.8-5.7 2.4l-3.5-3.6c2.4-2.4 5.7-3.8 9.2-3.8 3.5 0 6.8 1.4 9.2 3.8l-2.9 3z m5.4 15.5c0 1.4-1.2 2.5-2.5 2.5s-2.5-1.1-2.5-2.5v-3.3c0-1.5 0.8-2.5 1.6-2.5h3.2c0.1 0.5 0.2 1.4 0.2 2.5v3.3z m0-7.5h-1.7v-1.6c-0.2-2.1-1-4-2.2-5.6l1.5-1.5c1.5 2 2.4 4.4 2.4 7.1v1.6z' })
        )
    );
};

exports.default = TiHeadphones;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/headphones.js
// module id = 3095
// module chunks = 0